import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

// CSS
import "../CSS/Snowfall.css";

const sizeArray = [5, 6, 7];

const Snowfall = (props) => {
  const { color: snowflakesColor } = props;
  const snowContainerRef = useRef(null);

  useEffect(() => {
    const createSnowflake = () => {
      const snowflake = document.createElement("div");
      snowflake.className = "snowflake";

      // Random positions and styles
      const size = sizeArray[Math.floor(Math.random() * sizeArray.length)];
      snowflake.style.width = `${size}px`;
      snowflake.style.height = `${size}px`;
      snowflake.style.background = snowflakesColor;
      snowflake.style.position = "absolute";
      snowflake.style.left = `${Math.random() * 100}vw`;
      snowflake.style.top = `-10px`;
      snowflake.style.zIndex = 9999;
      snowflake.style.animationDelay = `${Math.random() * 5}s`;
      snowflake.style.animationDuration = `${5 + Math.random() * 5}s`;

      snowContainerRef.current.appendChild(snowflake);

      // Animate snowflake removal
      setTimeout(() => {
        gsap.to(snowflake, {
          opacity: 0,
          scale: 0,
          duration: 1,
          onComplete: () => snowflake.remove(),
        });
      }, 9000); // Trigger removal close to animation end
    };

    // Create snowflakes periodically
    const interval = setInterval(createSnowflake, 100);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <div
      ref={snowContainerRef}
      className="snow-container"
      style={{ zIndex: 2 }}
    ></div>
  );
};

export default Snowfall;
